import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import RoutesComponent from './Routes';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <React.StrictMode>
        <HelmetProvider>
            <RoutesComponent />
        </HelmetProvider>
    </React.StrictMode>
);

